import { deepCloning } from 'src/app/shared/utils/functions';
import { Cid } from './cid.model';
import { EventsAndDates } from './events-and-dates.model';
import { TumoralMarkers } from './markers.model';
import { Staging } from "./staging.model";
import { PathologicalAnatomy } from './pathological-anatomy.model';

export class Diagnostic {
  uniqueId!: string;
  conditionId!: string;
  creationDate!: Date | null;
  morphologicalSystemIntegration!: string;
  morphologicalLegacyDate!: Date | null;
  TNMversion!: string;
  cid!: Cid;
  staging: Staging;
  pathologicalAnatomy!: PathologicalAnatomy[];
  biologicalMarkers!: TumoralMarkers[];
  eventsAndDates!: EventsAndDates;
  dataSource: 'myClinic' | 'oncoOs' | '' = '';

  constructor() {
    this.uniqueId = crypto.randomUUID();
    this.conditionId = '';
    this.creationDate = null;
    this.morphologicalSystemIntegration = '';
    this.morphologicalLegacyDate = null;
    this.TNMversion = '7';
    this.cid = new Cid();
    this.staging = new Staging();
    this.pathologicalAnatomy = [];
    this.biologicalMarkers = [];
    this.eventsAndDates = new EventsAndDates();
  }

  setNewDiagnostic(params: Partial<Diagnostic>): Diagnostic {
    this.uniqueId = params.uniqueId ?? crypto.randomUUID();
    this.conditionId = params.conditionId ?? '';
    this.creationDate = params.creationDate ?? null;
    this.morphologicalSystemIntegration = params.morphologicalSystemIntegration ?? '';
    this.morphologicalLegacyDate = params.morphologicalLegacyDate ?? null;
    this.TNMversion = params.TNMversion ?? '7';
    this.dataSource = params.dataSource ?? 'oncoOs';
    this.cid = params.cid ?? new Cid();
    this.staging = params.staging ?? new Staging();
    this.pathologicalAnatomy = params.pathologicalAnatomy ?? [];
    this.biologicalMarkers = params.biologicalMarkers ?? [];
    this.eventsAndDates = params.eventsAndDates ?? new EventsAndDates();
    return this;
  }
}

export class DiagnosticApi {
  patientId: string;
  practitionerId: string;
  informations: Diagnostic | null;
  TNMversion: string;

  constructor(diagnostic: Diagnostic, patientId: string, practitionerId: string) {
    const diag = deepCloning(diagnostic);
    diag.creationDate === null ? diag.creationDate = new Date(Date.UTC(1900, 0, 1, 0, 0, 0, 0)) : '';
    this.patientId = patientId;
    this.practitionerId = practitionerId;
    this.informations = diag;
    this.TNMversion = diagnostic.TNMversion;
    return this;
  }
}
